export enum GettingStartedSubtask {
  WelcomeVideo = 'welcomeVideo',
  NavigationTour = 'navigationTour',
  SetUpRoles = 'setUpRoles',
  InviteYourTeam = 'inviteYourTeam',
  AdjustNotifications = 'adjustNotifications',
  SyncCalendarAndEmail = 'syncCalendarAndEmail',
  BuildHiringPipeline = 'buildHiringPipeline',
  SeeHowDisqualifyReasonsWork = 'seeHowDisqualifyReasonsWork',
  AddAdmin = 'addAdmin',
  CreateWebsiteAddress = 'createWebsiteAddress',
  CustomizeYourSite = 'customizeYourSite',
  CreateJob = 'createJob',
  PublishJob = 'publishJob',
  PipelineOverview = 'pipelineOverview',
  ScheduleCandidateInterview = 'scheduleCandidateInterview',
  CollaborativeHiring = 'collaborativeHiring',
  EvaluateCandidates = 'evaluateCandidates',
  ProceedOrDisqualify = 'proceedOrDisqualify',
  ConnectYourTools = 'connectYourTools',
  DiscoverNewApps = 'discoverNewApps',
  CreateEmailTemplates = 'createEmailTemplates',
  WriteJobDescriptions = 'writeJobDescriptions',
  BrowsePublishedJobs = 'browsePublishedJobs',
}

export enum GettingStartedStep {
  GetStarted = 'getStarted',
  AdjustSettings = 'adjustSettings',
  CreateCareersSite = 'createCareersSite',
  PostYourFirstJob = 'postYourFirstJob',
  ManageCandidates = 'manageCandidates',
  VisitOurMarketplace = 'visitOurMarketplace',
  ComposeYourMessaging = 'composeYourMessaging',
  ViewJobs = 'viewJobs',
}

export type GettingStartedConfig = {
  gettingStartedSteps: GettingStartedSubtaskType[];
  showAcademyButton: boolean;
};

export type GettingStartedSubtaskType = Record<GettingStartedSubtask, boolean>;

export type GetStartedSubtasks = Pick<
  GettingStartedSubtaskType,
  | GettingStartedSubtask.WelcomeVideo
  | GettingStartedSubtask.NavigationTour
  | GettingStartedSubtask.SetUpRoles
  | GettingStartedSubtask.InviteYourTeam
  | GettingStartedSubtask.AdjustNotifications
>;

export type AdjustSettingsSubtasks = Pick<
  GettingStartedSubtaskType,
  | GettingStartedSubtask.SyncCalendarAndEmail
  | GettingStartedSubtask.BuildHiringPipeline
  | GettingStartedSubtask.SeeHowDisqualifyReasonsWork
>;

export type CreateCareersSiteSubtasks = Pick<
  GettingStartedSubtaskType,
  | GettingStartedSubtask.AddAdmin
  | GettingStartedSubtask.CreateWebsiteAddress
  | GettingStartedSubtask.CustomizeYourSite
>;

export type PostYourFirstJobSubtasks = Pick<
  GettingStartedSubtaskType,
  GettingStartedSubtask.CreateJob | GettingStartedSubtask.PublishJob
>;

export type ManageCandidatesSubtasks = Pick<
  GettingStartedSubtaskType,
  | GettingStartedSubtask.PipelineOverview
  | GettingStartedSubtask.ScheduleCandidateInterview
  | GettingStartedSubtask.CollaborativeHiring
  | GettingStartedSubtask.EvaluateCandidates
  | GettingStartedSubtask.ProceedOrDisqualify
>;

export type VisitOurMarketplaceSubtasks = Pick<
  GettingStartedSubtaskType,
  GettingStartedSubtask.ConnectYourTools | GettingStartedSubtask.DiscoverNewApps
>;

export type ViewJobsSubtasks = Pick<
  GettingStartedSubtaskType,
  GettingStartedSubtask.BrowsePublishedJobs
>;

export type ComposeYourMessagingSubtasks = Pick<
  GettingStartedSubtaskType,
  GettingStartedSubtask.CreateEmailTemplates | GettingStartedSubtask.WriteJobDescriptions
>;

export type FirstUnfinishedStepAndSubtask = {
  step: GettingStartedStep | null;
  subtask: GettingStartedSubtask | null;
};
